import React from 'react';
import PropTypes from 'prop-types';
import EpicGamesFooter from 'epic-games-footer/app/scripts/EpicGamesFooter';
import styles from './Footer.pcss';

export default class Footer extends React.Component {
    static propTypes = {
        content: PropTypes.object,
        accountInfo: PropTypes.object
    };

    render() {
        const {content, accountInfo} = this.props;

        return (
            <div className={styles.footer}>
                <EpicGamesFooter
                    epicPropertyName="epic_games"
                    links={content.links || []}
                    isLoggedIn={true}
                    wrapperId="affiliateWrapper"
                    email={accountInfo.email || ''}
                    {...content}
                />
            </div>
        );
    }
}
